import { c as _c } from "react/compiler-runtime";
import { dota2_metablob_v1 } from '../../../convex/metablobs/dota2/v1';
import { HeroIcon } from './HeroIcon';
export const Dota2ActivityFace = t0 => {
  const $ = _c(22);
  const {
    metablob,
    size: t1,
    variant: t2
  } = t0;
  const size = t1 === undefined ? 96 : t1;
  const variant = t2 === undefined ? "normal" : t2;
  if (metablob?.playerHero == null) {
    return null;
  }
  const {
    playerHero: heroName,
    playerKills: heroKills,
    playerDeaths: heroDeaths,
    playerAssists: heroAssists
  } = metablob;
  const didWin = metablob.winner === metablob.playerTeam;
  if (variant === "slim") {
    const t3 = didWin ? "border-l-2 border-l-green-400" : "border-l-2 border-l-red-400";
    let t4;
    if ($[0] !== heroName || $[1] !== size || $[2] !== t3) {
      t4 = <HeroIcon heroId={heroName} size={size} variant="icon" className={t3} />;
      $[0] = heroName;
      $[1] = size;
      $[2] = t3;
      $[3] = t4;
    } else {
      t4 = $[3];
    }
    let t5;
    if ($[4] !== heroAssists || $[5] !== heroDeaths || $[6] !== heroKills) {
      t5 = <div>{heroKills}/{heroDeaths}/{heroAssists}</div>;
      $[4] = heroAssists;
      $[5] = heroDeaths;
      $[6] = heroKills;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    let t6;
    if ($[8] !== t4 || $[9] !== t5) {
      t6 = <div className="flex flex-row gap-2 items-center"><div className="flex flex-row gap-2 items-center">{t4}{t5}</div></div>;
      $[8] = t4;
      $[9] = t5;
      $[10] = t6;
    } else {
      t6 = $[10];
    }
    return t6;
  }
  const t3 = didWin ? "border-l-2 border-l-green-400" : "border-l-2 border-l-red-400";
  let t4;
  if ($[11] !== heroName || $[12] !== size || $[13] !== t3) {
    t4 = <HeroIcon heroId={heroName} size={size} className={t3} />;
    $[11] = heroName;
    $[12] = size;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== heroAssists || $[16] !== heroDeaths || $[17] !== heroKills) {
    t5 = <div>{heroKills}/{heroDeaths}/{heroAssists}</div>;
    $[15] = heroAssists;
    $[16] = heroDeaths;
    $[17] = heroKills;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t4 || $[20] !== t5) {
    t6 = <><div className="flex flex-row gap-1"><div className="flex flex-row gap-2 items-center">{t4}{t5}</div></div></>;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
};